import { required, minValue, numeric } from 'vuelidate/lib/validators';
import {
  alphaNumLite,
  bankAccountNumber,
  swiftCode,
  moneyFormat
} from '@/components/Form/validation/custom';

const datepicker = { required };
const inputText = { required };
const inputNumeric = { required, minValue: minValue(0), numeric };
const inputAccountNumber = { required, bankAccountNumber };
const inputSwift = { required, swiftCode };
const inputMoney = { required, moneyFormat };
const radio = { required };
const textArea = { required };
const textAreaBankDetails = { alphaNumLite };
const select = { required };

export {
  datepicker,
  inputText,
  inputNumeric,
  inputAccountNumber,
  inputSwift,
  inputMoney,
  radio,
  select,
  textArea,
  textAreaBankDetails
};
